// Helpers for external media links (YouTube / MP4) in the multimedia library.
export function ytId(url) {
  if (!url) return null;
  const m = String(url).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([\w-]{11})/);
  return m ? m[1] : null;
}
export function ytEmbed(url) {
  const id = ytId(url);
  return id ? `https://www.youtube.com/embed/${id}` : null;
}
export function vimeoId(url) {
  const m = String(url || "").match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return m ? m[1] : null;
}
export function mediaThumb(url) {
  const id = ytId(url);
  if (id) return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  const v = vimeoId(url);
  if (v) return `https://vumbnail.com/${v}.jpg`;
  return null;
}
export function isVideoFile(url) {
  return /\.(mp4|webm|ogg|mov|m4v)(\?.*)?$/i.test(String(url || ""));
}
